export default {
  green: '3C1',
  blue: '08C',
  red: 'E43',
  yellow: 'DB1',
  orange: 'F73',
  purple: '94E',
  pink: 'E5B',
  grey: '999',
  gray: '999',
  cyan: '1BC',
  black: '2A2A2A'
}
